const contactMessages = {
  en: {
    me: "Michal Jaskulski",
    mail: "mail: mjaskulski1@gmail.com",
    mobile: "mobile: +48 602 209 858",
    location: "Poland",
    contactme: "Feel Free To Contact Me Anytime",
    youremail: "Type your email",
    subject: "Subject",
    description: "Description",
    send: "Send",
    required: "This file is required",
    incorrectemail: "Incorrect email",
  },
  pl: {
    me: "Michał Jaskulski",
    mail: "mail: mjaskulski1@gmail.com",
    mobile: "tel.: 602 209 858",
    location: "Mikołów, śląskie",
    contactme: "Potrzebujesz więcej informacji, skontaktuj się ze mną",
    youremail: "Twój adres e-mail",
    subject: "Temat",
    description: "Opis",
    send: "Wyślij",
    required: "To pole jest wymagane",
    incorrectemail: "Nieprawidłowy adres email",
  },
};
export default contactMessages;
